import { useRecoilValue } from 'recoil';
import HouseBBRCorrectInformation from './HouseBBRCorrectInformation';
import { useState } from 'react';
import HouseBBREditInformation from './HouseBBREditInformation';
import { prhBBRAtom } from '../../../../recoil/atoms/prhBBRAtom';
import { track } from '../../../../utils/trackingUtil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';

const HouseAddressStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const bbrData = useRecoilValue(prhBBRAtom);
    const [isEditingBBR, setIsEditingBBR] = useState(false);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);

    const onNext = (): void => {
        track(`${currentProduct.flavourName}CoverableInformationBBRInformation`, [bbrData]);
        goNext();
    };

    return (
        <>
            {bbrData.isBBRComplete && !isEditingBBR ? (
                <HouseBBRCorrectInformation
                    bbrData={bbrData}
                    goNext={onNext}
                    goPrevious={goPrevious}
                    setIsEditingBBR={setIsEditingBBR}
                />
            ) : (
                <HouseBBREditInformation
                    setIsEditingBBR={setIsEditingBBR}
                    goPrevious={goPrevious}
                />
            )}
        </>
    );
};

export default HouseAddressStep;
